module.exports = __webpack_public_path__ + "static/media/Pancake_Parlour .cd435330.jpg";